// 국토교통부 실거래가 API 모의 데이터 (실제 앱에서는 API 호출)

import type { Transaction, TransactionSummary, MonthlyStats, ApartmentInfo } from '../types';

// 풍덕천동 실거래가 샘플 데이터 (이전에 수집한 데이터 기반)
export function getMockTransactions(): Transaction[] {
  return [
    // e편한세상수지
    { aptName: "e편한세상수지", dealDate: "2026.06.05", dealAmount: 164000, area: 84.921, floor: 24, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2026.06.01", dealAmount: 147000, area: 84.884, floor: 10, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2026.05.25", dealAmount: 153000, area: 84.929, floor: 18, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2025.09", dealAmount: 132000, area: 84.921, floor: 4, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2025.09", dealAmount: 137000, area: 84.884, floor: 23, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2025.09", dealAmount: 154000, area: 98.897, floor: 4, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2025.08", dealAmount: 133000, area: 84.921, floor: 24, buildYear: 2017, dongName: "풍덕천동" },
    { aptName: "e편한세상수지", dealDate: "2025.08", dealAmount: 135500, area: 84.921, floor: 30, buildYear: 2017, dongName: "풍덕천동" },
    
    // 수지파크푸르지오
    { aptName: "수지파크푸르지오", dealDate: "2026.04.20", dealAmount: 138000, area: 84.9023, floor: 15, buildYear: 2019, dongName: "풍덕천동" },
    { aptName: "수지파크푸르지오", dealDate: "2026.03.24", dealAmount: 116500, area: 59.8875, floor: 11, buildYear: 2019, dongName: "풍덕천동" },
    { aptName: "수지파크푸르지오", dealDate: "2025.12.19", dealAmount: 110000, area: 59.8875, floor: 23, buildYear: 2019, dongName: "풍덕천동" },
    { aptName: "수지파크푸르지오", dealDate: "2025.12.02", dealAmount: 107000, area: 59.7939, floor: 5, buildYear: 2019, dongName: "풍덕천동" },
    { aptName: "수지파크푸르지오", dealDate: "2025.11.25", dealAmount: 126500, area: 84.9023, floor: 5, buildYear: 2019, dongName: "풍덕천동" },
    { aptName: "수지파크푸르지오", dealDate: "2025.10.18", dealAmount: 90000, area: 59.8875, floor: 1, buildYear: 2019, dongName: "풍덕천동" },
    
    // 수지푸르지오월드마크
    { aptName: "수지푸르지오월드마크", dealDate: "2026.03.07", dealAmount: 75000, area: 84.26, floor: 9, buildYear: 2013, dongName: "풍덕천동" },
    { aptName: "수지푸르지오월드마크", dealDate: "2026.02.24", dealAmount: 77000, area: 84.27, floor: 10, buildYear: 2013, dongName: "풍덕천동" },
    { aptName: "수지푸르지오월드마크", dealDate: "2026.02.23", dealAmount: 78000, area: 84.61, floor: 16, buildYear: 2013, dongName: "풍덕천동" },
    { aptName: "수지푸르지오월드마크", dealDate: "2026.02.20", dealAmount: 77000, area: 84.26, floor: 21, buildYear: 2013, dongName: "풍덕천동" },
    { aptName: "수지푸르지오월드마크", dealDate: "2026.01.31", dealAmount: 68500, area: 84.61, floor: 17, buildYear: 2013, dongName: "풍덕천동" },
    { aptName: "수지푸르지오월드마크", dealDate: "2026.01.21", dealAmount: 76000, area: 98.35, floor: 18, buildYear: 2013, dongName: "풍덕천동" },
    
    // 진산마을삼성5차
    { aptName: "진산마을삼성5차", dealDate: "2025.01", dealAmount: 103000, area: 84.2102, floor: 8, buildYear: 2003, dongName: "풍덕천동" },
    { aptName: "진산마을삼성5차", dealDate: "2025.01", dealAmount: 120000, area: 155.328, floor: 6, buildYear: 2003, dongName: "풍덕천동" },
    { aptName: "진산마을삼성5차", dealDate: "2025.01", dealAmount: 93000, area: 84.2102, floor: 4, buildYear: 2003, dongName: "풍덕천동" },
    { aptName: "진산마을삼성5차", dealDate: "2024.12", dealAmount: 100000, area: 83.8821, floor: 16, buildYear: 2003, dongName: "풍덕천동" },
    { aptName: "진산마을삼성5차", dealDate: "2024.12", dealAmount: 108000, area: 114.002, floor: 8, buildYear: 2003, dongName: "풍덕천동" },
    
    // 풍덕천동 현대
    { aptName: "풍덕천동 현대", dealDate: "2026.06.06", dealAmount: 119000, area: 84.51, floor: 12, buildYear: 1994, dongName: "풍덕천동" },
    { aptName: "풍덕천동 현대", dealDate: "2026.06.06", dealAmount: 113800, area: 84.51, floor: 3, buildYear: 1994, dongName: "풍덕천동" },
    { aptName: "풍덕천동 현대", dealDate: "2026.06.02", dealAmount: 121000, area: 84.51, floor: 7, buildYear: 1994, dongName: "풍덕천동" },
    { aptName: "풍덕천동 현대", dealDate: "2025.01", dealAmount: 60000, area: 60.03, floor: 4, buildYear: 1994, dongName: "풍덕천동" },
    { aptName: "풍덕천동 현대", dealDate: "2025.01", dealAmount: 65500, area: 60.03, floor: 9, buildYear: 1994, dongName: "풍덕천동" },
    
    // 수지삼성2차
    { aptName: "수지삼성2차", dealDate: "2025.09", dealAmount: 70700, area: 59.9985, floor: 2, buildYear: 1997, dongName: "풍덕천동" },
    { aptName: "수지삼성2차", dealDate: "2025.09", dealAmount: 75500, area: 59.9985, floor: 4, buildYear: 1997, dongName: "풍덕천동" },
    { aptName: "수지삼성2차", dealDate: "2025.08", dealAmount: 78100, area: 74.1285, floor: 6, buildYear: 1997, dongName: "풍덕천동" },
    { aptName: "수지삼성2차", dealDate: "2025.06", dealAmount: 69000, area: 59.9985, floor: 11, buildYear: 1997, dongName: "풍덕천동" },
    { aptName: "수지삼성2차", dealDate: "2025.04", dealAmount: 77000, area: 74.1285, floor: 18, buildYear: 1997, dongName: "풍덕천동" },
    
    // 동아아파트
    { aptName: "동아아파트", dealDate: "2025.01", dealAmount: 44600, area: 59.76, floor: 5, buildYear: 1995, dongName: "풍덕천동" },
    { aptName: "동아아파트", dealDate: "2025.01", dealAmount: 46000, area: 59.76, floor: 9, buildYear: 1995, dongName: "풍덕천동" },
    { aptName: "동아아파트", dealDate: "2024.11", dealAmount: 47000, area: 59.76, floor: 10, buildYear: 1995, dongName: "풍덕천동" },
    { aptName: "동아아파트", dealDate: "2024.09", dealAmount: 48400, area: 59.76, floor: 6, buildYear: 1995, dongName: "풍덕천동" },
    
    // 신정마을주공1단지
    { aptName: "신정마을주공1단지", dealDate: "2026.04.25", dealAmount: 118800, area: 59.39, floor: 9, buildYear: 1996, dongName: "풍덕천동" },
    { aptName: "신정마을주공1단지", dealDate: "2026.04.17", dealAmount: 111500, area: 59.39, floor: 2, buildYear: 1996, dongName: "풍덕천동" },
    { aptName: "신정마을주공1단지", dealDate: "2026.04.15", dealAmount: 113000, area: 59.39, floor: 9, buildYear: 1996, dongName: "풍덕천동" },
    { aptName: "신정마을주공1단지", dealDate: "2026.03.31", dealAmount: 112000, area: 59.39, floor: 12, buildYear: 1996, dongName: "풍덕천동" },
    { aptName: "신정마을주공1단지", dealDate: "2026.03.25", dealAmount: 117000, area: 59.39, floor: 17, buildYear: 1996, dongName: "풍덕천동" },
  ];
}

// 아파트 요약 정보 계산
export function calculateSummary(transactions: Transaction[]): TransactionSummary[] {
  const aptMap = new Map<string, Transaction[]>();
  
  // 아파트별로 그룹화
  transactions.forEach(t => {
    const key = t.aptName;
    if (!aptMap.has(key)) {
      aptMap.set(key, []);
    }
    aptMap.get(key)!.push(t);
  });

  // 요약 계산
  const summaries: TransactionSummary[] = [];
  
  aptMap.forEach((trans, aptName) => {
    const prices = trans.map(t => t.dealAmount);
    const areas = trans.map(t => t.area);
    
    const avgPrice = Math.round(prices.reduce((a, b) => a + b, 0) / prices.length);
    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    
    // 평당가 계산 (1평 = 3.3058㎡)
    const avgArea = areas.reduce((a, b) => a + b, 0) / areas.length;
    const pyeong = avgArea / 3.3058;
    const avgPricePerPyeong = Math.round(avgPrice / pyeong);
    
    // 최근 거래 정렬 (날짜순)
    const sortedTrans = [...trans].sort((a, b) => {
      const dateA = a.dealDate.replace(/\./g, '');
      const dateB = b.dealDate.replace(/\./g, '');
      return dateB.localeCompare(dateA);
    });

    summaries.push({
      aptName,
      buildYear: trans[0].buildYear,
      avgPrice,
      minPrice,
      maxPrice,
      avgPricePerPyeong,
      transactionCount: trans.length,
      latestTransactions: sortedTrans.slice(0, 5),
    });
  });

  // 평당가 높은 순 정렬
  return summaries.sort((a, b) => b.avgPricePerPyeong - a.avgPricePerPyeong);
}

// 월별 통계 계산
export function calculateMonthlyStats(transactions: Transaction[]): MonthlyStats[] {
  const monthMap = new Map<string, Transaction[]>();
  
  transactions.forEach(t => {
    const month = t.dealDate.substring(0, 7).replace('.', '-');
    if (!monthMap.has(month)) {
      monthMap.set(month, []);
    }
    monthMap.get(month)!.push(t);
  });

  const stats: MonthlyStats[] = [];
  
  monthMap.forEach((trans, month) => {
    const prices = trans.map(t => t.dealAmount);
    
    stats.push({
      month,
      count: trans.length,
      avgPrice: Math.round(prices.reduce((a, b) => a + b, 0) / prices.length),
      minPrice: Math.min(...prices),
      maxPrice: Math.max(...prices),
    });
  });

  // 월별 정렬
  return stats.sort((a, b) => b.month.localeCompare(a.month));
}

// API 호출 함수 (실제 앱에서는 API 사용)
export async function fetchTransactions(regionCode: string): Promise<Transaction[]> {
  // 실제 앱에서는 국토교통부 API 호출
  // 예: https://apis.data.go.kr/1613000/AptGetPrcRgnHmQtyService/getAptList
  
  // 현재는 모의 데이터 반환
  console.log(`Fetching transactions for region: ${regionCode}`);
  return getMockTransactions();
}

// 아파트 정보 조회 (실제 앱에서는 API 사용)
export async function fetchApartmentInfo(aptName: string): Promise<ApartmentInfo | null> {
  console.log(`Fetching apartment info: ${aptName}`);
  
  // 모의 데이터
  const mockInfo: Record<string, ApartmentInfo> = {
    'e편한세상수지': { aptName: 'e편한세상수지', buildYear: 2017, totalUnits: 1160 },
    '수지파크푸르지오': { aptName: '수지파크푸르지오', buildYear: 2019, totalUnits: 892 },
    '수지푸르지오월드마크': { aptName: '수지푸르지오월드마크', buildYear: 2013, totalUnits: 1128 },
    '진산마을삼성5차': { aptName: '진산마을삼성5차', buildYear: 2003, totalUnits: 820 },
    '풍덕천동 현대': { aptName: '풍덕천동 현대', buildYear: 1994, totalUnits: 1168 },
    '수지삼성2차': { aptName: '수지삼성2차', buildYear: 1997, totalUnits: 688 },
    '동아아파트': { aptName: '동아아파트', buildYear: 1995, totalUnits: 490 },
    '신정마을주공1단지': { aptName: '신정마을주공1단지', buildYear: 1996, totalUnits: 1050 },
  };
  
  return mockInfo[aptName] || null;
}